module.exports = __webpack_public_path__ + "media/images/logos/kaleido-logo-cedacfad154c11b99894649ec0d1ac69.svg";